module.exports = __webpack_public_path__ + "divider.7ad8dbb0.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/divider.svg
// module id = yxgM
// module chunks = 0